

export const setProjects = (data) => {
    return {
        type: 'SET_PROJECTS',
        data
    }
};


export const setFocusedProject = (data) => {
    return {
        type: 'SET_FOCUSED_PROJECT',
        data
    }
}

export const setFocusedLoanEstimate = (data) => {
    return {
        type: 'SET_FOCUSED_LOAN_ESTIMATE',
        data
    }
}